import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion'; // Importa motion da framer-motion
import { useInView } from 'react-intersection-observer'; // Importa useInView per rilevare l'entrata nella vista
import { useLanguage } from '../context/LanguageContext'; // Importa useLanguage

function Contact() {
    const address = "Via Albenga 3/5, Nettuno (RM)";
    const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    const { isEnLang } = useLanguage(); // Ottieni la lingua corrente dal contesto

    const translations = {
        en: {
            title: "Contact Us for an Unforgettable Stay",
            position: "Position",
            phone: "Phone",
            email: "Email",
        },
        it: {
            title: "Contattaci per un Soggiorno Indimenticabile",
            position: "Posizione",
            phone: "Telefono",
            email: "Email",
        }
    };

    const { title, position, phone, email } = isEnLang ? translations.en : translations.it;

    const { ref, inView } = useInView();

    const variants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <motion.section
            ref={ref}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 0.5 }}
            className="contact l-1260"
            id="contact"
        >
            <div className="title">
                <h2>{title}</h2>
            </div>
            <div className="content-contact">
                <motion.div
                    className="contact-item"
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={variants}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    <div>
                        <h3><FontAwesomeIcon icon={faMapMarkerAlt} /> {position}</h3>
                        <p><a href={mapLink} target="_blank" rel="noopener noreferrer">{address}</a></p>
                    </div>
                </motion.div>
                <motion.div
                    className="contact-item"
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={variants}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    <div>
                        <h3 className="contact-title"><FontAwesomeIcon icon={faPhone} /> {phone}</h3>
                        <p className="contact-info"><a href="tel:+393928729907">392 872 9907</a></p>
                    </div>
                </motion.div>
                <motion.div
                    className="contact-item"
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={variants}
                    transition={{ duration: 0.5, delay: 0.3 }}
                >
                    <div>
                        <h3 className="contact-title"><FontAwesomeIcon icon={faEnvelope} /> {email}</h3>
                        <p className="contact-info"><a href="mailto:almasuitebb@gmail.com">almasuitebb@gmail.com</a></p>
                    </div>
                </motion.div>
            </div>
            <iframe
                title="Mappa B&B Alma Suite"
                className="contact-map"
                src="https://maps.google.com/maps?q=Via+Albenga+3%2F5%2C+Nettuno+RM&output=embed"
                allowFullScreen
                loading="lazy"
            />
        </motion.section>
    );
}

export default Contact;
